import { useState } from 'react';

import { EditableImage } from './types';

export const useImageCache = () => {
  const [imageCache, setImageCache] = useState<Map<string, EditableImage>>(
    new Map(),
  );

  const addToCache = (key: string, image: EditableImage) => {
    setImageCache((prev) => {
      prev.set(key, image);
      return prev;
    });
  };

  const getFromCache = (key: string): EditableImage | undefined => {
    return imageCache.get(key);
  };

  return { addToCache, getFromCache, imageCache };
};
